<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="转外修"
        width="400px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="emRepairOrder"
          :rules="ruleValidate"
          class="form"
          label-width="80px">
        <el-form-item label="工单编号">
          <el-input v-model="emRepairOrder.no" readonly placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="emRepairOrder.equipmentName" readonly placeholder="选择"/>
        </el-form-item>
        <el-form-item label="修理方式" prop="repairType">
          <template>
            <el-radio-group v-model="emRepairOrder.repairType" disabled>
              <el-radio :label="10">内修</el-radio>
              <el-radio :label="20">外修</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
        <el-form-item label="OA申请号" prop="oaNo">
          <el-input v-model="emRepairOrder.oaNo" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


  export default {
    name:"EMRepairOrderOut",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        emRepairOrder: {
          pkid: 0,
          no: "",
          equipmentName: "",
          oaNo: "",
        },
        ruleValidate: {
          oaNo: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.emRepairOrder.pkid = id;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic", `repairOrders/${this.emRepairOrder.pkid}`)
          .then(resp => {
            this.emRepairOrder = resp.data;
            console.log(this.emRepairOrder);
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "repairOrders/edit", this.emRepairOrder)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
